export const environment = {
  production: true,
  // api_endpoint: 'https://api.pbsnap.me/api/v1',
  // api_domain: 'https://api.pbsnap.me',
  api_endpoint: 'https://api-test.pbsnap.me/api/v1',
  api_domain: 'https://api-test.pbsnap.me',
  // URL ของเว็บฝั่งลูกค้า (pb-snap-web-customer) ใช้สร้างลิงก์แชร์ Gallery
  customer_web_url: 'https://gallery-test.pbsnap.me',
  api_manage_endpoint: 'http://noc.easynet.co.th:8092/api/v1',
  api_manage_domain: 'http://noc.easynet.co.th:8092/',
  api_report_endpoint: 'https://report.jobtime.info/api/v1',
  api_report_domain: 'https://report.jobtime.info'
};
